// @ts-nocheck
import { DetailBatchRecord } from '../../../../interfaces/_models'
import { CustomHeader } from './CustomHeader'

const detailsColumns: ReadonlyArray<Column<DetailBatchRecord>> = [
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Nombres' className='min-w-125px' />
    ),
    id: 'name',
    Cell: ({...props}) => (
      <span className='text-primary-dark'>{props.data[props.row.index].name}</span>
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Usuario fri' className='min-w-125px' />
    ),
    id: 'username',
    Cell: ({...props}) => <span>{props.data[props.row.index].username}</span>,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Teléfono' className='min-w-125px' />
    ),
    id: 'phone',
    Cell: ({...props}) => <span className='text-gray'>{props.data[props.row.index].phoneNumber}</span>,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Monto a pagar' className='min-w-125px text-end' />
    ),
    id: 'amount',
    Cell: ({...props}) => <span className='text-primary-dark'>{props.data[props.row.index].amount}</span>,
  },
]

const completedDetailsColumns: ReadonlyArray<Column<DetailBatchRecord>> = [
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='No. de autorización' className='min-w-125px' />
    ),
    id: 'authorizationNumber',
    Cell: ({...props}) => (
      <span className='text-primary-dark'>{props.data[props.row.index].authorizationNumber}</span>
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Nombres' className='min-w-125px' />
    ),
    id: 'name',
    Cell: ({...props}) => (
      <span className='text-primary-dark'>{props.data[props.row.index].name}</span>
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Usuario fri' className='min-w-125px' />
    ),
    id: 'username',
    Cell: ({...props}) => <span>{props.data[props.row.index].username}</span>,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Teléfono' className='min-w-125px' />
    ),
    id: 'phone',
    Cell: ({...props}) => <span className='text-gray'>{props.data[props.row.index].phoneNumber}</span>,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Monto a pagar' className='min-w-125px text-end' />
    ),
    id: 'amount',
    Cell: ({...props}) => <span className='text-primary-dark'>{props.data[props.row.index].amount}</span>,
  },
]

const errorDetailColumns: ReadonlyArray<Column<DetailBatchRecord>> = [
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Usuario fri' className='min-w-125px' />
    ),
    id: 'username',
    Cell: ({...props}) => (
      <span className='text-primary-dark'>{props.data[props.row.index].username}</span>
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Referencia' className='min-w-125px' />
    ),
    id: 'reference',
    Cell: ({...props}) => <span>{props.data[props.row.index].reference}</span>,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Tipo de error' className='min-w-125px' />
    ),
    id: 'errorMessage',
    Cell: ({...props}) => <span className='text-danger'>{props.data[props.row.index].errorMessage}</span>,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Monto' className='min-w-125px text-end' />
    ),
    id: 'amount',
    Cell: ({...props}) => <span className='text-primary-dark'>{props.data[props.row.index].amount}</span>,
  },
]

export {detailsColumns, errorDetailColumns, completedDetailsColumns}
